import { IWalkthroughModel } from 'src/services/client-types';

export interface IWalkthroughSummaryStats {
  totalWalkthroughs: number;
  totalEmailsSent: number;
  emailsFailedCount: number;
  isEmailMode: boolean;
  isActivatedMode: boolean;
}

export const getWalkthroughSummaryStats = (
  walkthroughs: IWalkthroughModel[]
): IWalkthroughSummaryStats => {
  const totalWalkthroughs: number = walkthroughs.length;

  const totalEmailsSent: number = walkthroughs.filter(
    (walkthrough: IWalkthroughModel) => walkthrough.isEmailSent
  ).length;

  const isActivatedMode: boolean = walkthroughs.some(
    (walkthrough: IWalkthroughModel) => walkthrough.status === 'Schedule'
  );

  const emailsFailedCount: number = totalWalkthroughs - totalEmailsSent;
  const isEmailMode: boolean = totalEmailsSent > 0;

  return {
    totalWalkthroughs,
    totalEmailsSent,
    emailsFailedCount,
    isEmailMode,
    isActivatedMode,
  };
};
